// extracted by mini-css-extract-plugin
export default {"wrapper":"SecondLevelMenu_wrapper__uzhsP","list":"SecondLevelMenu_list__H8VDL","listItem":"SecondLevelMenu_listItem__U97mM","anchor":"SecondLevelMenu_anchor__Rm8KK"};